/**
 * 肉多多 interval 訂位流程的共享狀態。
 *
 * 步驟編號沿用 prototype/booking.html：
 *   1 = 門市／時段搜尋（原型的 searchView）
 *   3 = 填寫訂位資料
 *   4 = OTP 驗證
 *   5 = 完成
 * 刻意不重新編號成 1/2/3/4：原型與本檔要能互相對照，
 * 兩邊步驟號一致才不會在追 bug 時對錯畫面。
 */
import { reactive } from 'vue';
/**
 * 用餐目的選項。
 *
 * ⚠️ 字串值必須與後端 OrderPurpose enum 完全一致，不可為了好看改字面，
 * 後端收到未知值會直接擋下建單。
 *
 * 顯示順序依 2026-10-06 定案；「朋友慶生」「週年慶」已隱藏（後端仍接受，舊單照常顯示）。
 */
export const PURPOSES = [
    'birthday',
    'date',
    'special-day',
    'family',
    'business',
    'friend-gathering',
];
/**
 * 今天（台北牆上日期）。
 *
 * 不可用 toISOString()——那是 UTC，台北凌晨 0~8 點會變成前一天，
 * 客人一開頁就看到昨天的可訂時段。en-CA 直接給 YYYY-MM-DD。
 */
export function taipeiToday() {
    return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Taipei' });
}
/** 以台北日期計算未來日期，避免瀏覽器時區造成日期偏移。 */
export function taipeiDateAfter(days) {
    const date = new Date(taipeiToday() + 'T00:00:00+08:00');
    date.setUTCDate(date.getUTCDate() + days);
    return date.toLocaleDateString('en-CA', { timeZone: 'Asia/Taipei' });
}
export const bookingState = reactive({
    step: 1,
    // 預設 2 人（2026-08-18 門市要求，需求書 B-1）：用餐幾乎不會只有 1 人，
    // 預設 1 等於每個客人都要多點一次。
    // ⚠️ 這個值不只是輸入框的初始數字 —— 客人一進訂位頁，系統就會拿它去查
    // 當天的可訂時段，所以改預設值會連帶改變客人一開頁看到的時段清單。
    // 門市上限低於此值時由 clampParty() 收斂（至少保留 1 位大人）。
    adult: 2,
    child: 0,
    childSeat: 0,
    date: taipeiToday(),
    storeId: 0,
    storeName: '',
    // 選定門市的訂位須知／溫馨提醒（依當前語系取好的字串）。
    // 存在 state 而不是重新查一次：客人選完店就進填資料頁，
    // 為了跳一個彈窗再打一次 API 沒有必要，門市清單裡本來就帶著這兩欄。
    storeInstruction: '',
    storeNotice: '',
    slot: null,
    name: '',
    gender: 0,
    countryCode: '+886',
    phone: '',
    email: '',
    purpose: [],
    note: '',
    verificationType: '',
    verificationId: '',
    verifyDest: '',
    otpVerifiedToken: '',
    orderNo: '',
    orderShortUrl: '',
});
/** 總人數（兒童椅不計入，只受兒童數限制）。 */
export function partySize() {
    return bookingState.adult + bookingState.child;
}
